<ng-container [ngTemplateOutlet]="variant === 'default' ? defaultTemplate : bottomsheetTemplate"></ng-container>

<ng-template #defaultTemplate>
  <div class="tw-overflow-hidden tw-mb-3 tw-rounded-t-[18px]"
    (click)="gotoProduct.emit(product)">
    <img class="tw-w-full tw-h-full"
      #image=""
      alt="{{ product?.title }}"
         [src]="
        product?.rebrandedImageWithBackground?.[0] ||
        product?.productUnboxedImage?.[0] ||
        product?.images?.[0]
      " />
  </div>
  <h2 class="tw-flex-1 tw-font-body tw-text-200 tw-text-center tw-mx-4"
    (click)="gotoProduct.emit(product)">
    {{ product.title.substr(0, 25) }}
  </h2>
  <div class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-mb-3 tw-mx-4"
    (click)="gotoProduct.emit(product)">
    <p class="tw-font-body tw-font-bold tw-text-300 tw-line-through">
      ₹{{ product.mrp }}
    </p>
    <p class="tw-font-body tw-font-bold tw-text-300 tw-text-orange-500">
      ₹{{ product.price }}
    </p>
  </div>

  @if (isShopRevampExperimentOn) {
    @if (productQuantity > 0) {
      <div class="tw-h-8 tw-border tw-border-teal-600 tw-rounded-2 tw-flex tw-px-1 tw-w-fit tw-items-center tw-text-200 tw-font-bold tw-bg-white tw-text-teal-600">
        <em class="cs-icon-minus  tw-h-full tw-px-5" (click)='reomveFromCart.emit(product)'></em>
        <span>{{ productQuantity }}</span>
        <em class="cs-icon-plus  tw-h-full tw-px-5" (click)="addToCart.emit({ product, image })"></em>
      </div>
    }
  } @else {
    @if (productQuantity > 0) {
      <div class="tw-h-8 tw-border tw-border-teal-600 tw-rounded-3 tw-flex tw-justify-evenly tw-items-center tw-mx-4 tw-text-200 tw-font-bold tw-font-body tw-bg-white tw-text-teal-600"
        >
        <em class="cs-icon-minus" (click)='reomveFromCart.emit(product)'></em>
        <span>{{ productQuantity }}</span>
        <em class="cs-icon-plus" (click)="addToCart.emit({ product, image })"></em>
      </div>
    }
  }


  @if (isShopRevampExperimentOn) {
    @if (productQuantity === 0) {
      <div
        (click)="addToCart.emit({ product, image })"
        class="tw-w-fit tw-h-8 tw-flex tw-items-center tw-text-center tw-justify-center tw-text-white tw-font-bold tw-text-300 tw-bg-teal-600 tw-rounded-3 tw-px-[26px]">
        <span i18n="@@add">Add</span>
      </div>
    }
  } @else {
    @if (productQuantity === 0) {
      <div
        (click)="addToCart.emit({ product, image })"
        class="tw-h-8 tw-flex tw-items-center tw-text-center tw-justify-center tw-gap-1 tw-text-white tw-font-bold tw-text-200 tw-mx-4 tw-bg-teal-600 tw-rounded-3">
        <span i18n="@@addToCart">Add to Cart</span>
        <cs-icon class="tw-h-5 tw-w-5" [iconName]="'chevron_right'"></cs-icon>
      </div>
    }
  }
</ng-template>

<ng-template #bottomsheetTemplate>
  <div class="tw-overflow-hidden tw-mb-2 tw-rounded-2"
    (click)="gotoProduct.emit(product)">
    <div class="tw-relative">
      <img class="tw-w-full tw-h-full"
        alt="{{ product?.title }}"
        #image
        [src]="product?.imageUrl" />
      <ng-content [select]="'tag'"></ng-content>
    </div>
  </div>
  <h2 class="tw-flex-1 tw-font-body tw-font-bold tw-text-200 tw-mb-2 tw-line-clamp-2"
    (click)="gotoProduct.emit(product)">
    {{ product.titleInUserLanguage }}
  </h2>
  <div class="tw-flex tw-items-center tw-gap-2 tw-font-normal tw-text-gray-500 tw-text-200 tw-mb-3"
    (click)="gotoProduct.emit(product)">
    <p class="tw-font-body tw-font-bold tw-text-300 tw-line-through">
      ₹{{ product.MRP }}
    </p>
    <p class="tw-font-body tw-font-bold tw-text-300 tw-text-orange-500">
      ₹{{ product.SP }}
    </p>
  </div>
  @if (productQuantity > 0) {
    <div
      class="tw-w-20 tw-flex tw-justify-evenly tw-items-center tw-text-green-400 tw-text-200 tw-font-bold tw-font-body tw-h-8 tw-border tw-border-teal-600 tw-rounded-2 tw-bg-white">
      <em class="cs-icon-minus"
      (click)="reomveFromCart.emit(product)"></em>
      <span>{{ productQuantity }}</span>
      <em class="cs-icon-plus"
      (click)="addToCart.emit({ product, image })"></em>
    </div>
  }
  @if (productQuantity === 0) {
    <div
      (click)="addToCart.emit({ product, image })"
      class="tw-text-center tw-py-[7px] tw-w-full tw-rounded-2 tw-bg-teal-600 tw-font-body tw-font-bold tw-text-200 tw-text-white">
      <span i18n="@@add">Add</span>
    </div>
  }
</ng-template>